module.exports = __webpack_public_path__ + "img/v1.5.9fd5b7f3.png";